import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button 
      className="theme-toggle" 
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <div className="theme-toggle-track">
        <Sun size={14} className="theme-icon sun" />
        <Moon size={14} className="theme-icon moon" />
        <div className={`theme-toggle-thumb ${isDark ? 'dark' : ''}`} />
      </div>
    </button>
  );
};

export default ThemeToggle;
